<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>Customer Form</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="formClose">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-items>
                <v-btn dark text v-if="snackbar.save_button" @click="reset">Save</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-stepper v-model="e6" vertical>
            <v-stepper-step :complete="e6 > 1" step="1">
                Customer Form
                <small>Fill Out The Customer Record Form</small>
            </v-stepper-step>

            <v-stepper-content step="1">
                <form class="px-2">
                    <v-row>
                        <v-text-field v-model="formData_1.NumberOfPerson"
                                      label="Number of Person"
                                      clearable
                                      class="col-sm-6 col-md-4"
                                      required
                                      :error-messages="NumberOfPersonErrors"
                                      @input="$v.formData_1.NumberOfPerson.$touch()"
                                      @blur="$v.formData_1.NumberOfPerson.$touch()"></v-text-field>
                        <v-autocomplete v-model="formData_1.Country"
                                        :items="countries"
                                        label="Country"
                                        clearable
                                        single-line
                                        item-text="value"
                                        item-value="id"
                                        class="col-sm-6 col-md-4"
                                        @change="getState"
                                        :error-messages="CountryErrors"
                                        @input="$v.formData_1.Country.$touch()"
                                        @blur="$v.formData_1.Country.$touch()"></v-autocomplete>

                        <v-autocomplete v-model="formData_1.State"
                                        :items="state"
                                        label="State"
                                        clearable
                                        single-line
                                        item-text="value"
                                        item-value="id"
                                        class="col-sm-6 col-md-4"></v-autocomplete>
                        <v-text-field v-model="formData_1.Address" label="Address" clearable class="col-sm-6 col-md-4"></v-text-field>
                        <v-text-field v-model="formData_1.ContactNumber"
                                      label="Contact Number"
                                      clearable
                                      class="col-sm-6 col-md-4"></v-text-field>
                        <v-menu v-model="snackbar.menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                class="col-sm-6 col-md-4"
                                min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="formData_1.CheckInDate"
                                              label="Check In Date"
                                              clearable
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="formData_1.CheckInDate" :error-messages="CheckInDateErrors"
                                           @input="$v.formData_1.CheckInDate.$touch()"
                                           @blur="$v.formData_1.CheckInDate.$touch()"></v-date-picker>

                        </v-menu>
                        <v-menu v-model="snackbar.menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                class="col-sm-6 col-md-4"
                                min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="formData_1.CheckOutDate"
                                              label="Check Out Date"
                                              clearable
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="formData_1.CheckOutDate" :error-messages="CheckOutDateErrors"
                                           @input="$v.formData_1.CheckOutDate.$touch()"
                                           @blur="$v.formData_1.CheckOutDate.$touch()" @change="GetRoomStatus"></v-date-picker>
                        </v-menu>
                        <v-autocomplete v-model="formData_1.Room"
                                        :items="rooms"
                                        chips
                                        deletable-chips
                                        label="Rooms"
                                        clearable
                                        multiple
                                        item-text="roomDisplay"
                                        item-value="roomID"
                                        class="col-sm-6 col-md-4"
                                        @change="getPrice"
                                        :error-messages="RoomErrors"
                                        @input="$v.formData_1.Room.$touch()"
                                        @blur="$v.formData_1.Room.$touch()"></v-autocomplete>
                        <v-autocomplete v-model="formData_1.Package"
                                        :items="packages"
                                        label="Package"
                                        clearable
                                        single-line
                                        item-text="value"
                                        item-value="id"
                                        class="col-sm-6 col-md-4"
                                        @change="getPrice"></v-autocomplete>
                        <v-autocomplete v-model="formData_1.Service"
                                        :items="services"
                                        chips
                                        deletable-chips
                                        label="Services"
                                        clearable
                                        multiple
                                        item-text="value"
                                        item-value="id"
                                        class="col-sm-6 col-md-4"
                                        @change="getServicePrice"></v-autocomplete>
                        <v-switch class="col-sm-6 col-md-4"
                                  v-model="formData_1.isCustomerOnPackage"
                                  label="Is Customer On Package?"
                                  clearable
                                  @change="getPrice"></v-switch>
                        <div class="col-12">
                            <v-col md="4">

                                Total Fare : RS {{snackbar.price}}
                            </v-col>
                            <v-col md="4">
                                Service Charge: RS {{snackbar.ServicePrice}}

                            </v-col>
                            <br />
                            <v-btn dark depressed class="mr-4 green darken-1" @click="form_1Post">Save</v-btn>
                            <!-- <v-btn dark depressed class="mr-4 indigo darken-4" @click="form_next" :disabled="!snackbar.next_button">Next</v-btn>-->
                        </div>
                    </v-row>
                </form>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" step="2">Customer Information</v-stepper-step>

            <v-stepper-content step="2">
                <v-expansion-panels>
                    <v-expansion-panel v-for="(item,i) in snackbar.number_of_second_form" :key="i">
                        <v-expansion-panel-header>Person {{item}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <form class="px-2">
                                <v-row>
                                    <v-text-field
                                            label="First Name"
                                            v-model="formData_2[i].FirstName"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Last Name"
                                            v-model="formData_2[i].LastName"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-model="formData_2[i].Country"
                                            :items="countries"
                                            label="Country"
                                            clearable
                                            single-line
                                            item-text="value"
                                            item-value="id"
                                            class="col-sm-6 col-md-4"
                                            @change="getState"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-model="formData_2[i].State"
                                            :items="state"
                                            label="State"
                                            clearable
                                            single-line
                                            item-text="value"
                                            item-value="id"
                                            class="col-sm-6 col-md-4"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-model="formData_2[i].Gender"
                                            :items="gender"
                                            label="Gender"
                                            clearable
                                            single-line
                                            item-text="value"
                                            item-value="id"
                                            class="col-sm-6 col-md-4"
                                    ></v-autocomplete>
                                    <v-text-field
                                            label="Age"
                                            v-model="formData_2[i].Age"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                            type="number"
                                    ></v-text-field>
                                    <v-text-field
                                            label="CitizenShipNumber"
                                            v-model="formData_2[i].CitizenShipNumber"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                    ></v-text-field>
                                    <v-text-field
                                            label="PassportNumber"
                                            v-model="formData_2[i].PassportNumber"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                    ></v-text-field>
                                    <v-text-field
                                            label="LicenseNumber"
                                            v-model="formData_2[i].LicenseNumber"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                    ></v-text-field>
                                    <v-text-field
                                            label="OtherID"
                                            v-model="formData_2[i].OtherID"
                                            clearable
                                            class="col-sm-6 col-md-4"
                                    ></v-text-field>
                                </v-row>
                            </form>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <div class="col-4">
                    <v-btn dark depressed class="mr-4 green darken-1" @click="form_2Post">Save</v-btn>
                </div>
            </v-stepper-content>
            <v-stepper-step :complete="e6 > 3" step="3">Bill</v-stepper-step>

            <v-stepper-content step="3">
                <v-form>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field :value="snackbar.price+snackbar.ServicePrice " label="Price To Be Paid" disabled></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="BillForm.PaidAmount" label="Paid Amount"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" >
                                <v-autocomplete v-model="BillForm.PaymentType" :items="paymentType" label="Payment Type"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" >
                                <v-text-field v-model="BillForm.DueAmount" label="Due Amount"></v-text-field>
                            </v-col>
                            <v-col cols="12"></v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <div class="col-4">
                    <v-btn
                            dark
                            depressed
                            class="mr-4 green darken-1"
                            @click="form_3Post"
                            :disabled="!snackbar.next_button"
                    >Save</v-btn>
                </div>
            </v-stepper-content>
        </v-stepper>
        <v-snackbar v-model="snackbar.snackbar" :timeout="snackbar.timeout" top color="error">
            {{ snackbar.text }}
            <v-btn text @click="snackbar.snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
    /*import { email, maxLength,, sameAs } from "vuelidate/lib/validators";*/
    import axios from "axios";
    import {required} from "vuelidate/lib/validators";
    export default {
        name: "CreateHotelCustomerForm",
        props: ["pendingData"],
        data() {
            return {
                e6: 1,
                step: 1,
                snackbar: {
                    snackbar: false,
                    text: "Internal Server Error,Please Contact Admin",
                    timeout: 200000,
                    menu2: false,
                    menu3: false,
                    save_button: false,
                    next_button: true,
                    success: false,
                    error: false,
                    number_of_second_form: 1,
                    HotelCustomerID: 1,
                    price: 0,
                    ServicePrice: 0
                },
                paymentType:['CASH','CHEQUE','CARD'],
                formData_1: {},
                formData_2: [],
                formData_2_Object: {},
                formDatas: {},
                BillForm: {},
                rooms: [],
                services: [],
                packages: [],
                RoomObject: {},
                countries: [],
                state: [],
                gender:[]
            };
        },
        computed: {
            NumberOfPersonErrors() {
                const errors = [];
                if (!this.$v.formData_1.NumberOfPerson.$dirty) return errors;
                !this.$v.formData_1.NumberOfPerson.required &&
                errors.push("Number of person is required");
                return errors;
            },
            CountryErrors() {
                const errors = [];
                if (!this.$v.formData_1.Country.$dirty) return errors;
                !this.$v.formData_1.Country.required &&
                errors.push("Country is required");
                return errors;
            },
            CheckInDateErrors() {
                const errors = [];
                if (!this.$v.formData_1.CheckInDate.$dirty) return errors;
                !this.$v.formData_1.CheckInDate.required &&
                errors.push("Check in date is required");
                return errors;
            },
            CheckOutDateErrors() {
                const errors = [];
                if (!this.$v.formData_1.CheckOutDate.$dirty) return errors;
                !this.$v.formData_1.CheckOutDate.required &&
                errors.push("Check Out date is required");
                return errors;
            },
            RoomErrors() {
                const errors = [];
                if (!this.$v.formData_1.Room.$dirty) return errors;
                !this.$v.formData_1.Room.required &&
                errors.push("Room is required");
                return errors;
            },
        },
        validations: {
            formData_1: {
                NumberOfPerson: { required },
                Country: { required },
                CheckInDate: { required },
                CheckOutDate: { required },
                Room: { required }
            }
        },
        mounted() {
            this.formData();
            this.addForm_2_Parameter();
        },

        methods: {
            async getState(val){
                const stateList = await axios.get('Shared/StateListByCountryCode?CountryCode='+val);
                this.state= stateList.data
            },
            formClose(val) {
                console.log(val);
                this.$emit("formResponseClose", val);
            },
            addForm_2_Parameter() {
                this.formData_2.push({
                    FirstName: "",
                    LastName: "",
                    Country: this.countries,
                    State: "",
                    Gender: "",
                    Age: 0,
                    CitizenShipNumber: "",
                    PassportNumber: "",
                    LicenseNumber: "",
                    OtherID: "",
                    Document: "",
                    IsVerifiedDocument: false
                });
            },
            async formData() {

                const packagelist = await axios.get("Hotel/DDLPackageListAsync");
                const servicelist = await axios.get("Hotel/DDLHotelServiceListAsync");
                const counteryList = await axios.get("Shared/CountryList");
                const genderList = await axios.get("Shared/GenderList");
                this.gender = genderList.data;
                this.countries = counteryList.data;

                this.packages = packagelist.data;
                this.services = servicelist.data;
            },
            getServicePrice() {
                let param = {
                    "HotelCustomerServiceID": this.formData_1.Service
                }
                axios
                    .post("Hotel/GetHotelServiceAmount", param)
                    .then(response => {
                        this.snackbar.ServicePrice = response.data;
                        console.log(this.snackbar.price);
                    })
                    .catch(() => {
                        this.snackbar.error = true;
                        this.snackbar.snackbar = true;
                        this.snackbar.success = false;
                        this.snackbar.text = "Could not Fetch the price";
                    });
            },
            getPackagePrice(val) {
                console.log(val);
                axios
                    .post("Hotel/GetHotelPakageAmount", val)
                    .then(response => {
                        this.snackbar.price = response.data;
                        console.log(this.snackbar.price);
                    })
                    .catch(() => {
                        this.snackbar.error = true;
                        this.snackbar.snackbar = true;
                        this.snackbar.success = false;
                        this.snackbar.text = "Could not Fetch the price";
                    });
            },
            getPrice() {

                let  fareAmountParam = {
                    "roomIDs" : this.formData_1.Room,
                    "packageID": parseInt(this.formData_1.Package),
                    "isCustomerOnPackage" : this.formData_1.isCustomerOnPackage,
                    "NumberOfPerson": parseInt(this.formData_1.NumberOfPerson)
                }
                axios
                    .post("Hotel/GetPackageOrRoomFareAmountAsync", fareAmountParam)
                    .then(response => {
                        this.snackbar.price = response.data;
                        console.log(this.snackbar.price);
                    })
                    .catch(() => {
                        this.snackbar.error = true;
                        this.snackbar.snackbar = true;
                        this.snackbar.success = false;
                        this.snackbar.text = "Could not Fetch the price";
                    });
            },
            form_1Post() {
                this.$v.formData_1.$touch();
                if (this.$v.formData_1.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    this.formDatas = {
                        NumberOfPerson: parseInt(this.formData_1.NumberOfPerson),
                        Country: this.formData_1.Country,
                        State: this.formData_1.State,
                        Address: this.formData_1.Address,
                        ContactNumber: this.formData_1.ContactNumber,
                        CheckInDate: this.formData_1.CheckInDate,
                        CheckOutDate: this.formData_1.CheckOutDate,
                        Room: this.formData_1.Room,
                        HotelCustomerServiceID: this.formData_1.Service,
                        HotelPackageID: this.formData_1.Package,
                        IsCustomerOnPackage: this.formData_1.IsCustomerOnPackage
                    };
                    axios
                        .post("Hotel/InsertIntoHotelCustomerAsync", this.formDatas)
                        .then(response => {
                            console.log(response.data);
                            this.$v.formData_1.$reset();
                            this.snackbar.success = response.data.success;
                            this.snackbar.number_of_second_form = this.formDatas.NumberOfPerson;
                            this.snackbar.next_button = !this.snackbar.next_button;
                            this.snackbar.HotelCustomerID = response.data.id;
                            this.snackbar.error = false;
                            this.snackbar.snackbar = false;
                            for (
                                let step = 1;
                                step < this.snackbar.number_of_second_form;
                                step++
                            ) {
                                console.log("inside loop", step);
                                this.addForm_2_Parameter();
                            }
                            this.e6++;
                            this.formData_1 = {};
                        })
                        .catch(() => {
                            this.snackbar.error = true;
                            this.snackbar.snackbar = true;
                            this.snackbar.success = false;
                        });
                }
            },
            form_2Post() {
                /*this.e6 = 4;*/
                this.formData_2_Object.List = this.formData_2;
                this.formData_2_Object.HotelCustomerID = this.snackbar.HotelCustomerID;

                console.log("Data:", this.formData_2_Object);
                axios
                    .post(
                        "Hotel/InsertIntoHotelCustomerInformationAsync",
                        this.formData_2_Object
                    )
                    .then(response => {
                        console.log(response.data);
                        this.snackbar.success = response.data.success;
                        this.snackbar.number_of_second_form = 1;
                        this.snackbar.next_button = !this.snackbar.next_button;
                        this.formData_2_Object = {};
                        this.e6++;
                    })
                    .catch(() => {
                        this.snackbar.error = true;
                        this.snackbar.snackbar = true;
                        this.snackbar.success = false;
                        this.snackbar.text = "Internal Server Error, Please Contact Admin";
                    });
            },
            form_3Post() {
                // this.BillForm.HotelCustomerID = this.snackbar.HotelCustomerID
                let form = {
                    HotelCustomerID: this.snackbar.HotelCustomerID,
                    PaidAmount: parseFloat(this.BillForm.PaidAmount),
                    PaymentType: this.BillForm.PaymentType,
                    DueAmount: parseFloat(this.BillForm.DueAmount),
                    AmountToPay: parseFloat(this.snackbar.price+this.snackbar.ServicePrice)
                };

                axios
                    .post("Hotel/InsertIntoHotelCustomerBillAsync", form)
                    .then(response => {
                        console.log(response.data);
                        this.snackbar.success = response.data.success;
                        this.snackbar.next_button = false;
                        this.snackbar.save_button = true;
                        this.snackbar.text = "Customer Added Successfully !";
                        this.$emit("formResponse", this.snackbar);
                    })
                    .catch(() => {
                        this.snackbar.error = true;
                        this.snackbar.snackbar = true;
                        this.snackbar.success = false;
                        this.snackbar.text = "Internal Server Error, Please Contact Admin";
                    });
            },
            reset() {
                this.save_button = false;
                this.e6 = 1;
                this.$emit("FormClose", this.dialogue);
                this.snackbar.next_button = true;
            },
            checkRate(ActualRate, PaidPrice) {
                this.BillForm.DueAmount = (ActualRate.price + ActualRate.ServicePrice) - PaidPrice;
            },
           async GetRoomStatus() {
                let data = {
                    "bookedFromDate": this.formData_1.CheckInDate,
                    "bookedToDate": this.formData_1.CheckOutDate,
                    "isDropDown": true
                };
                let roomlist= await axios.post(
                    "Hotel/RoomStatusListAsync",
                    data
               )
               console.log(roomlist.data)
                this.rooms = roomlist.data;
            }
        }
    };
</script>

<style scoped>
</style>
